import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import roc360 from "../../../assets/roc360.png"
import { InternalValuationReviewStore } from "../../../stores/internalValuationReviewStore";
import { observer } from "mobx-react";
import { getFullAddress } from "../../../utils/utils";
import { SubjectPropertyBox } from "../subjectPropertyBox";
import { CurrentPropertyStatusBox } from "../currentPropertyStatusBox";
import { SubjectNeighborhoodInfoBox } from "../subjectNeighborhoodInfoBox";
import { AdverseExternalFactorsBox } from "../adverseExternalFactorsBox";
import { ScopeOfWorkBox } from "./scopeOfWorkBox";
import { ReportHeader } from "../reportHeader";

const useStyles = makeStyles(() => ({
  page: {
    fontFamily: "Roboto, Arial, sans-serif",
    border: "1px solid lightgray",
    borderRadius: "5px",
    width: "1018px",
    height: "1440px",
    padding: "64px 40px 64px 40px",
  },
  header: {
    marginRight: "40px",
    marginBottom: "20px",
  },
  lenderLogo: {
    width: "232px",
    height: "114px",
  },
  valuationTitle: {
    fontSize: "inherit",
    color: "#1C3F78",
    lineHeight: "1",
    fontWeight: 100,
  },
  reportTitle: {
    fontSize: "inherit",
    color: "#2EC2C9",
    lineHeight: "1",
    fontWeight: "bolder",
  },
}));

interface Page1Props {
  internalValuationReviewStore: InternalValuationReviewStore;
}

export const Page1 = observer(({ internalValuationReviewStore }: Page1Props) => {
  const classes = useStyles();

  const internalValuationData = internalValuationReviewStore.initialData;
  const internalValuationReview = internalValuationData.internalValuationReview;

  const address = internalValuationReviewStore.initialData.propertyFullAddress; //getFullAddress(internalValuationReview);

  const propertyStatusInformation = internalValuationData.propertyStatusInformation;
  const neighborhoodHousingConditions = internalValuationData.neighborhoodHousingConditions;

  let recommendedImage = internalValuationData?.propertyImages?.find(image => image.recommendedPreview === "true")?.url;

  if (!recommendedImage) {
    recommendedImage = (internalValuationData?.propertyImages && internalValuationData?.propertyImages.length > 0) ? internalValuationData?.propertyImages[0].url : null;
  }

  return (
    <div className={classes.page}>
      <header className={classes.header}>
        <ReportHeader
          logoImg={<img src={roc360} alt="Roc 360 Logo" className={classes.lenderLogo} />}
          valuationTitleClassName={classes.valuationTitle}
          reportTitleClassName={classes.reportTitle} />
      </header>
      <main>
        <Grid container spacing={2}>
          <Grid item>
            <SubjectPropertyBox recommendedImage={recommendedImage} address={address} internalValuationReview={internalValuationReview} />
          </Grid>
          <Grid item xs={12}>
            <CurrentPropertyStatusBox propertyStatusInformation={propertyStatusInformation} />
          </Grid>
          <Grid item xs={12}>
            <SubjectNeighborhoodInfoBox internalValuationReview={internalValuationReview} neighborhoodHousingConditions={neighborhoodHousingConditions} />
          </Grid>
          <Grid item xs={12}>
            <AdverseExternalFactorsBox adverseFactorsComments={internalValuationReview.adverseFactorsComments} />
          </Grid>
          {internalValuationReviewStore.hasScopeOfWork && <Grid item xs={12}>
            <ScopeOfWorkBox
              renovationBudget={internalValuationReviewStore.renovationBudget}
              completedRenovation={internalValuationReviewStore.completedRenovation}
              totalRenovationBudget={internalValuationReviewStore.totalRenovationBudget}
              scopeOfWorkDescription={internalValuationReview.scopeOfWorkDescription} />
          </Grid>}
        </Grid>
      </main>
    </div>
  );
});